"use client";

import { useState } from "react";
import { Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const [expanded, setExpanded] = useState<Record<number, boolean>>({});
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const testimonials = [{
    quote: "Wij zijn met SocialComplex gaan samenwerken op basis van vertrouwen in de mensen achter het bedrijf, niet op basis van een lange lijst met resultaten. Twee jonge ondernemers met energie, ambitie en de wil om zichzelf te bewijzen. Dat bleek vanaf dag één zichtbaar in hun inzet. In drie maanden tijd hebben zij ervoor gezorgd dat er wekelijks structureel content online kwam, van podcastfragmenten en educatieve video's tot creatieve sketches. Daarnaast ondersteunden ze ons tijdens opnamedagen en dachten ze actief mee over het proces. Wat mij het meest is bijgebleven, is hun mentaliteit. Natuurlijk worden er fouten gemaakt wanneer je met elkaar groeit, maar zodra iets niet goed was, werd het direct opgepakt. Geen excuses, geen discussie, maar: \"We gaan het fixen.\" Vaak was het dezelfde avond nog opgelost. De resultaten lieten een duidelijke groei zien in bereik, views en engagement. Maar belangrijker nog: Social Complex is leergierig, professioneel, betrouwbaar en prettig om mee samen te werken. Voor organisaties die op zoek zijn naar een betrokken social media partner die verantwoordelijkheid neemt en bereid is een stap extra te zetten, kan ik hen van harte aanbevelen.\xA0",
    italicPhrase: "unmatched precision",
    quoteEnd: "",
    name: "Kevin Algemgeest",
    city: "Amsterdam, NL",
    date: "Oct 2024",
    avatar: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-26-jun-2026-22_46_08.png?v=0e7gav7wg76d",
    avatarSrcset: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-26-jun-2026-22_46_08.png?v=2xwo4v6szyr-wvc-srcset",
    avatarSizes: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-26-jun-2026-22_46_08.png?v=8pdx0y0hrey-wvc-sizes"
  }, {
    quote: "Eerlijke en professionele jongens die echt weten waar ze over praten. Ze denken actief met je mee, geven waardevolle adviezen en zijn altijd op de hoogte van de nieuwste trends op social media. Dankzij hun aanpak groeit je online zichtbaarheid en bereik je meer mensen via je sociale kanalen. De communicatie verloopt prettig en ze leveren kwaliteit. Zeker een aanrader! \xA0\xA0",
    italicPhrase: "high-velocity results",
    quoteEnd: "",
    name: "Barbershop Zutphen",
    city: "Rotterdam, NL",
    date: "Sep 2024",
    avatar: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/barbershop_logo_circle-1.png?v=q22lr229rwm",
    avatarSrcset: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/1d463c3d-7cd3-4edc-b6e4-9dfde6838596-3.png?v=sjzltxpyz4-wvc-srcset",
    avatarSizes: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/1d463c3d-7cd3-4edc-b6e4-9dfde6838596-3.png?v=k2w89vjzs-wvc-sizes"
  }, {
    quote: "A sharp, technical atelier where every detail is",
    italicPhrase: "deeply considered",
    quoteEnd: ". We saw immediate impact on our conversion rates after the first sprint.",
    name: "Elena K.",
    city: "Utrecht, NL",
    date: "Aug 2024",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/client_elena.webp",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/client_elena.webp-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/client_elena.webp-wvc-sizes"
  }, {
    quote: "Onboarding was seamless, the strategy was thorough, and the growth is",
    italicPhrase: "exactly what we aimed for",
    quoteEnd: ". Their data-driven approach is truly refreshing.",
    name: "Thomas B.",
    city: "Eindhoven, NL",
    date: "Jul 2024",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/client_thomas.webp",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/client_thomas.webp-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/client_thomas.webp-wvc-sizes"
  }];
  const fixedTestimonials = testimonials.slice(0, 2);
  return <section data-section-id="1387" id="wat-klanten-zeggen" className="bg-background text-foreground py-24 md:py-32 font-default">
      <div ref={ref} className={`mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
      transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
    }}>
        <div className="flex flex-col items-center text-center mb-16 md:mb-20">
          <h2 className="font-default font-bold text-white uppercase" style={{
          fontSize: "clamp(2rem, 5vw, 3.5rem)",
          letterSpacing: "-0.02em",
          lineHeight: 1.1
        }}>WAT KLANTEN&nbsp;<span className="text-orange-500" data-ast-id="f:/src/pages/Home/sections/Testimonials.tsx|sig:sc5mpt" data-ast-start="4783" data-ast-end="4827" contenteditable="false" style={{}}>ZEGGEN:&nbsp;</span></h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {fixedTestimonials.map((t, i) => <article key={i} data-index={i} className="border border-gray-800 rounded-lg p-8 h-full flex flex-col justify-between items-center">
              

              {i === 0 ? <p onClick={() => setExpanded({
            ...expanded,
            [i]: !expanded[i]
          })} className="text-white flex-1 mb-8 text-center cursor-pointer hover:opacity-75 transition-opacity" style={{
            fontSize: "1.125rem",
            lineHeight: 1.6
          }}>
                  {expanded[i] ? t.quote : `${t.quote.slice(0, 180)}...`}
                  {" "}
                  {t.quoteEnd}
                  <span className="block mt-2 text-orange-500 font-semibold text-sm">
                    {expanded[i] ? "- Minder lezen" : "+ Meer lezen"}
                  </span>
                </p> : <p className="text-white flex-1 mb-8 text-center" style={{
            fontSize: "1.125rem",
            lineHeight: 1.6
          }}>
                  {t.quote}{" "}
                  {t.quoteEnd}
                </p>}

              <div className="flex items-center gap-4 pt-6 border-t border-gray-800 w-full justify-center">
                <div className={`h-12 w-12 ${i === 0 ? "rounded-full" : "rounded-full"} overflow-hidden border border-gray-700 shrink-0`}>
                  <img src={t.avatar} data-wvc-srcset={t.avatarSrcset} data-wvc-sizes={t.avatarSizes} alt={t.name} className={`h-full w-full object-cover ${i === 0 ? "rounded-full" : "rounded-full"}`} loading="lazy" />
                </div>
                <div>
                  <div className="font-default font-bold text-white text-lg">
                    {t.name}
                  </div>
                  
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}